module.exports = __webpack_public_path__ + "static/media/inc_quarantine_myway.040c7240.svg";